<ng-container *ngIf="(isLoadingSeatMap$|async) === false; else placeholder">
  <div *ngIf="(sectorAndFlightSelected$|async) as sector;" class="container-seat-map">
    <div class="header">
      <div class="content-back-button">
        <ng-container *ngIf="userId$ | async as userID">
          <span class="back-button" (click)="goBack(userID)">
            <i aria-hidden="true" class="icon-arrow-down"></i>
          </span>
        </ng-container>
      </div>
      <h1 (click)="toggleSelectSector()">{{'SEAT_MAP_MODULE.TITLE_SELECT_SEATS'|transloco}}</h1>
      <div class="box-header" (click)="toggleSelectSector()">
        <div class="left">
          <p>{{sectorType(sector.SectorNumber)|transloco|uppercase}}</p>
        </div>
        <div class="center">
          <span>•</span>
          <p *ngIf="sector"> {{sector?.Flights[0]?.DepartureDate| date: 'EEE, d MMM yyyy' | dateFormat|titlecase}}</p>
          <i aria-hidden="true" class="icon-arrow-down"></i>
        </div>
        <div class="right">
          <i aria-hidden="true" class="icon-user"></i> <span>{{itineraryDetail?.Passengers.length}}</span>
        </div>
      </div>
      <div class="box-flights">
        <div class="box-flight" *ngFor="let flight of sector.Flights; let i = index"
          (click)="selectFlight(itineraryDetail,sector.SectorNumber,flight)">
          <div class="flight">
            <div class="content" [class.active]="flight?.IsSelected">
              <p>{{flight?.DepartureAirport}}</p>
              <i aria-hidden="true" class="icon-arrow-down icon-center"></i>
              <p>{{flight?.ArrivalAirport}}</p>
              <i aria-hidden="true" class="icon-arrow-down icon-right" *ngIf="showArrowRight(flight,sector.Flights)"></i>
            </div>
            <div class="line" [class.active]="flight?.IsSelected"></div>
          </div>
        </div>
      </div>
      <div class="box-indicators">
        <div class="box-indicator occupied">
          <span></span>
          <p>
            {{'SEAT_MAP_MODULE.NOT_AVAILABLE'|transloco}}
          </p>
        </div>
        <div class="box-indicator available">
          <span></span>
          <p>
            {{'SEAT_MAP_MODULE.AVAILABLE'|transloco}}
          </p>
        </div>
        <div class="box-indicator selected">
          <span></span>
          <p>
            {{'SEAT_MAP_MODULE.SELECTED'|transloco}}
          </p>
        </div>
      </div>
    </div>
    <div class="map">
      <ng-container *ngIf="(isLoadingSeatMapFlight$|async) === false; else placeholderSeatMapFlight">
        <app-seats-map [seatMapSeat]="(seatMapSeat$|async)" [seatMap]="(seatMap$|async)"></app-seats-map>
      </ng-container>
    </div>
    <div class="bottom-container" *ngIf="(isLoadingSeatMapFlight$|async) === false">
      <div class="container-passengers" [class.show-detail]="showDetailSeats" [style.margin-top.px]="topDetailSeats"
        [style.height.px]="heightDetailSeats">
        <ng-container *ngIf="seatMapSeat$|async as seats">
          <ng-container *ngIf="onePassenger(itineraryDetail.Passengers);else multiplePassenger">
            <div class="one-passenger">
              <div class="name">
                {{seats[0].FirstName}} {{seats[0].Surname}}
              </div>
              <ng-container *ngIf="seats[0].SeatNumber;else notSelected">
                <div class="seat">{{seats[0].SeatNumber}}</div>
                <i aria-hidden="true" class="icon-trash" (click)="removeSeatInFlight(seats[0].SeatNumber,null)"></i>
              </ng-container>
              <ng-template #notSelected>
                <span class="not-selected">{{'SEAT_MAP_MODULE.NO_SEAT'|transloco}}</span>
              </ng-template>

            </div>
          </ng-container>
          <ng-template #multiplePassenger>
            <ng-container *ngIf="showDetailSeats;else closeDetailSeats">
              <div class="title-open">
                <div class="title">{{'SEAT_MAP_MODULE.SEATING'|transloco}}</div>
                <i aria-hidden="true" class="icon-arrow-drop-up" (click)="closeDetailSeat()"></i>
              </div>
              <div class="one-passenger detail" *ngFor="let passenger of seats">
                <div class="name">
                  {{passenger.FirstName}} {{passenger.Surname}}
                </div>
                <ng-container *ngIf="passenger.SeatNumber;else notSelected">
                  <div class="seat">{{passenger.SeatNumber}}</div>
                  <i aria-hidden="true" class="icon-trash" (click)="removeSeatInFlight(passenger.SeatNumber,seats.length)"></i>
                </ng-container>
                <ng-template #notSelected>
                  <span class="not-selected">{{'SEAT_MAP_MODULE.NO_SEAT'|transloco}}</span>
                </ng-template>

              </div>
            </ng-container>
            <ng-template #closeDetailSeats>
              <ng-container *ngIf="filterSeatsSelectedMultiplePassengers(seatMapSeat$|async) as seatsSelected">
                <div class="list-seats-selecteds">
                  <div class="box-left">
                    <div class="title">{{'SEAT_MAP_MODULE.SEATING'|transloco}}</div>
                    <div class="container-box-passenger">
                      <div class="box-passenger" *ngIf="seatsSelected[0]">
                        <span class="name">{{seatsSelected[0].Name | uppercase}}</span>
                        <i aria-hidden="true" class="icon-arrow-drop-up"></i>
                        <span class="seat-number">{{seatsSelected[0].SeatNumber}}</span>
                      </div>
                      <div class="box-passenger" *ngIf="seatsSelected[1]">
                        <span class="name">{{seatsSelected[1].Name| uppercase}}</span>
                        <i  aria-hidden="true" class="icon-arrow-drop-up"></i>
                        <span class="seat-number">{{seatsSelected[1].SeatNumber}}</span>
                      </div>
                      <div class="box-passenger-number" *ngIf="seatsSelected[0].TotalNumber">
                        <i aria-hidden="true" class="icon-person-outline"></i>
                        <span class="number">+{{seatsSelected[0].TotalNumber}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="box-right" (click)="openDetailSeats(seatsSelected.length+seatsSelected[0].TotalNumber)">
                    <i aria-hidden="true" class="icon-arrow-drop-up"></i>
                  </div>
                </div>
              </ng-container>
            </ng-template>
          </ng-template>
        </ng-container>
      </div>

      <button
        *ngIf="(seatMap$ | async) as seatMap"
        [disabled]="!enableConfirm(seatMap?.Seats)"
        [class.enabled]="enableConfirm(seatMap?.Seats)"
        [class.loading]="isLoadingSeatMapTransactions"
        (click)="saveSeatsConfirm(seatMap, itineraryDetail)">
        <ng-container *ngIf="!isLoadingSeatMapTransactions;else loading">
          <i aria-hidden="true" class="icon-arrow-forw"></i>
        </ng-container>
        <ng-template #loading>
          <app-btn-loader [classColor]="loaderColor"></app-btn-loader>
        </ng-template>
      </button>
    </div>
  </div>
</ng-container>

<ng-template #placeholder>
  <app-seat-map-mobile-placeholder></app-seat-map-mobile-placeholder>
</ng-template>
<ng-template #placeholderSeatMapFlight>
  <app-seat-map-flight-placeholder></app-seat-map-flight-placeholder>
</ng-template>

<app-swipe-up [height]="63" [showSwipeUp]="showSelectSector" [classType]="'search'"
  (toggleShowSwipeUp)="toggleSelectSector()">
  <ng-container content>
    <app-select-sector-mobile  [itineraryDetail]="itineraryDetail" (selectSector)="toggleSelectSector()"></app-select-sector-mobile>
  </ng-container>
</app-swipe-up>

<ng-container *ngIf="showError"> 
  <ng-container *ngIf="seatMapErrors !== null">
    <app-form-error [imageUrl]="supportImg" [title]="translate(seatMapErrors?.Title)" [description]="translate(seatMapErrors?.Description)"
      [textButton]="translate(seatMapErrors?.MainButtonText)" [textSecondaryButton]="translate(seatMapErrors?.SecondaryButtonText)"
      (closed)="closeError(seatMapErrors)" (mainButton)="closeError(seatMapErrors)" [isMobile]="true"
      (secondaryButton)="otherOption(seatMapErrors)">
    </app-form-error>
  </ng-container>
</ng-container>

